module.exports = __webpack_public_path__ + "img/prioritas_vippack_k.64179d8b.png";